import mapboxgl from "mapbox-gl";
import circleFromCoords from "@turf/circle";
import GeoappAPI from "../apis/gemmiciApiService/GeoappAPI";

// Variables
const SYMBOL_TEXT_COLOR = "#042f33";
const SYMBOL_TEXT_FONTSIZE = 13;
const SYMBOL_TEXT_FONTS = ["Open Sans Regular", "Arial Unicode MS Regular"];
const HOVER_ACTIVE_SYMBOL_TEXT_FONTS = [
  "Open Sans SemiBold",
  "Arial Unicode MS Regular"
];
const ACTIVE_SYMBOL_TEXT_FONTS = ["Open Sans Bold", "Arial Unicode MS Bold"];

export default {
  initMap(bbox) {
    mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_STUDIO_ACCESS_TOKEN;
    let map = new mapboxgl.Map({
      container: "map", // container id
      style: "mapbox://styles/kevin-fabre/ckceic65k0oz51jo186nb1tgs", // stylesheet location
      bounds: [
        [bbox[0], bbox[1]],
        [bbox[2], bbox[3]]
      ],
      trackResize: true,
      maxBounds: this.bboxToBounds(this.getMaxBbox())
    });
    // Add zoom and rotation controls to the map.
    map.addControl(new mapboxgl.NavigationControl());
    return map;
  },
  addFixedLayers(map) {
    map.addLayer({
      id: "postsLayer",
      type: "background",
      paint: {
        "background-opacity": 0
      }
    });
    map.addLayer(
      {
        id: "locationLayer",
        type: "background",
        paint: {
          "background-opacity": 0
        }
      },
      "postsLayer"
    );
  },
  fitBounds(map, bbox) {
    map.fitBounds([
      [bbox[0], bbox[1]],
      [bbox[2], bbox[3]]
    ]);
  },
  initLocationLayer(map, longitude, latitude, shortName, placeType, radius) {
    var layers = map.getStyle().layers;
    for (let i = 0; i < layers.length; i++) {
      if (
        layers[i].id ===
        ("search-administrative-fill" || "search-administrative-line")
      ) {
        /* Remove search-region layers */
        map.removeLayer("search-administrative-fill");
        map.removeSource("search-administrative-fill");
        map.removeLayer("search-administrative-line");
        map.removeSource("search-administrative-line");
        break;
      }
      if (layers[i].id === ("search-region-fill" || "search-region-line")) {
        /* Remove search-region layers */
        map.removeLayer("search-region-fill");
        map.removeSource("search-region-fill");
        map.removeLayer("search-region-line");
        map.removeSource("search-region-line");
        break;
      }
      /* Remove search-city layers */
      if (layers[i].id === ("search-city-fill" || "search-city-line")) {
        map.removeLayer("search-city-fill");
        map.removeSource("search-city-fill");
        map.removeLayer("search-city-line");
        map.removeSource("search-city-line");
        break;
      }
      /* Remove search-department layers */
      if (
        layers[i].id === ("search-department-fill" || "search-department-line")
      ) {
        map.removeLayer("search-department-fill");
        map.removeSource("search-department-fill");
        map.removeLayer("search-department-line");
        map.removeSource("search-department-line");
        break;
      }
      /* Remove search-poi layers */
      if (layers[i].id === "search-poi") {
        map.removeLayer("search-poi");
        map.removeSource("search-poi");
      }
      /* Remove my-Posirion layers */
      if (
        layers[i].id === ("search-myPosition-fill" || "search-myPosition-fill")
      ) {
        map.removeLayer("search-myPosition-line");
        map.removeLayer("search-myPosition-fill");
        map.removeSource("search-myPosition-line");
        map.removeSource("search-myPosition-fill");
      }
    }
    /* Retrieve coordinates if coordinates are egal 0*/
    let geojson = null;
    if (
      /myPosition/.test(placeType) ||
      (radius &&
        radius !== 5 &&
        /poi|address|neighborhood|locality/.test(placeType)) ||
      (radius && radius !== 10 && placeType === "place")
    ) {
      let circle = circleFromCoords([longitude, latitude], radius);
      map.addLayer(
        {
          id: "search-myPosition-fill",
          type: "fill",
          source: {
            type: "geojson",
            data: circle
          },
          paint: {
            "fill-opacity": 0.05,
            "fill-color": "#104f55",
            "fill-outline-color": "#104f55"
          }
        },
        "locationLayer"
      );
      map.addLayer(
        {
          id: "search-myPosition-line",
          type: "line",
          source: {
            type: "geojson",
            data: circle
          },
          paint: {
            "line-width": 1,
            "line-color": "#104f55"
          }
        },
        "locationLayer"
      );
    } else if (placeType === "region") {
      GeoappAPI.retrieveRegionBorderAPI({ shortName })
        .then(response => {
          geojson = response.data.geometry;
          map.addLayer(
            {
              id: "search-region-fill",
              type: "fill",
              source: {
                type: "geojson",
                data: geojson
              },
              paint: {
                "fill-opacity": 0.05,
                "fill-color": "#104f55",
                "fill-outline-color": "#104f55"
              }
            },
            "locationLayer"
          );
          map.addLayer(
            {
              id: "search-region-line",
              type: "line",
              source: {
                type: "geojson",
                data: geojson
              },
              paint: {
                "line-width": 1,
                "line-color": "#104f55"
              }
            },
            "locationLayer"
          );
        })
        .catch();
    } else if (placeType === "administrative") {
      GeoappAPI.retrieveAdministrativeBorderAPI({
        shortName,
        longitude,
        latitude
      })
        .then(response => {
          geojson = response.data.geometry;
          map.addLayer(
            {
              id: "search-administrative-fill",
              type: "fill",
              source: {
                type: "geojson",
                data: geojson
              },
              paint: {
                "fill-opacity": 0.1,
                "fill-color": "#104f55",
                "fill-outline-color": "white"
              }
            },
            "locationLayer"
          );
          map.addLayer(
            {
              id: "search-administrative-line",
              type: "line",
              source: {
                type: "geojson",
                data: geojson
              },
              paint: {
                "line-width": 2,
                "line-color": "#104f55"
              }
            },
            "locationLayer"
          );
        })
        .catch();
    } else if (placeType === "department") {
      GeoappAPI.retrieveDepartmentBorderAPI({
        shortName,
        longitude,
        latitude
      })
        .then(response => {
          geojson = response.data.geometry;
          map.addLayer(
            {
              id: "search-department-fill",
              type: "fill",
              source: {
                type: "geojson",
                data: geojson
              },
              paint: {
                "fill-opacity": 0.1,
                "fill-color": "#104f55",
                "fill-outline-color": "white"
              }
            },
            "locationLayer"
          );
          map.addLayer(
            {
              id: "search-department-line",
              type: "line",
              source: {
                type: "geojson",
                data: geojson
              },
              paint: {
                "line-width": 2,
                "line-color": "#104f55"
              }
            },
            "locationLayer"
          );
        })
        .catch();
    } else if (placeType === "place") {
      GeoappAPI.retrieveCityBorderAPI({ shortName, longitude, latitude })
        .then(response => {
          geojson = response.data.geometry;
          map.addLayer(
            {
              id: "search-city-fill",
              type: "fill",
              source: {
                type: "geojson",
                data: geojson
              },
              paint: {
                "fill-opacity": 0.1,
                "fill-color": "#104f55",
                "fill-outline-color": "white"
              }
            },
            "locationLayer"
          );
          map.addLayer(
            {
              id: "search-city-line",
              type: "line",
              source: {
                type: "geojson",
                data: geojson
              },
              paint: {
                "line-width": 2,
                "line-color": "#104f55"
              }
            },
            "locationLayer"
          );
        })
        .catch();
    } else if (/poi|address|locality|neighborhood/.test(placeType)) {
      map.addSource("search-poi", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: [longitude, latitude]
              }
            }
          ]
        }
      });
      map.addLayer({
        id: "search-poi",
        type: "symbol",
        source: "search-poi",
        layout: {
          "icon-image": "pin-poi",
          "icon-size": 1,
          "icon-rotate": 45,
          "icon-anchor": "bottom-left",
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
          "text-field": shortName,
          "text-size": 11,
          "text-anchor": "center",
          "text-offset": [10, 0],
          "text-font": [
            "Roboto Black",
            "Open Sans Regular",
            "Arial Unicode MS Regular"
          ],
          "text-allow-overlap": true,
          "text-ignore-placement": true
        },
        paint: {
          "text-halo-blur": 0,
          "text-color": "rgba(16,79,85,1)",
          "text-halo-color": "rgba(255,255,255,1)",
          "text-halo-width": 1
        }
      });
    }
  },
  initDesktopDestinationsLayer(map, destinations) {
    const locationsOfDestinations = destinations.map(destination => {
      let location = destination.location;
      location.properties.mainPicture = destination.mainPicture;
      location.properties.destinationId = destination.id;
      location.properties.distance = destination.distance;
      location.properties.category = destination.category.nameEn.replace(
        /\s/g,
        ""
      );
      return location;
    });
    // RESET Layer before new destinations display
    const layer = map.getLayer("desktopDestinations");
    if (typeof layer !== "undefined") {
      // Remove map layer & source.
      map
        .removeLayer("desktopDestinations")
        .removeSource("desktopDestinations");
    }
    map.addLayer({
      id: "desktopDestinations",
      type: "symbol",
      source: {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: locationsOfDestinations
        }
      },
      layout: {
        "icon-image": ["get", "category"],
        "icon-size": 1,
        "icon-anchor": "center",
        "icon-allow-overlap": true,
        "icon-ignore-placement": false,
        "symbol-sort-key": 1000,
        "text-field": ["get", "shortName"],
        "text-size": SYMBOL_TEXT_FONTSIZE,
        "text-font": SYMBOL_TEXT_FONTS,
        "text-variable-anchor": ["top", "left", "right"],
        "text-radial-offset": 1,
        "text-optional": true,
        "text-allow-overlap": false,
        "text-ignore-placement": false
      },
      paint: {
        "text-color": SYMBOL_TEXT_COLOR,
        "text-halo-color": "rgba(255,255,255,1)",
        "text-halo-width": 1
      }
    });
    map.on("mouseenter", "desktopDestinations", e => {
      // Change mouse form when hover icon.
      map.getCanvas().style.cursor = "pointer";
      const layer = map.getLayer("highlight-desktopDestinations");
      if (typeof layer !== "undefined") {
        // Remove map layer & source.
        map
          .removeLayer("highlight-desktopDestinations")
          .removeSource("highlight-desktopDestinations");
      }
      // Add highlighted layer
      map.addLayer({
        id: "highlight-desktopDestinations",
        type: "symbol",
        source: {
          type: "geojson",
          data: e.features[0]
        },
        layout: {
          "icon-image": ["concat", ["get", "category"], "-hover"],
          "icon-size": 1,
          "icon-anchor": "center",
          "icon-allow-overlap": true,
          "icon-ignore-placement": false,
          "symbol-sort-key": 1000,
          "text-field": ["get", "shortName"],
          "text-size": SYMBOL_TEXT_FONTSIZE,
          "text-font": SYMBOL_TEXT_FONTS,
          "text-variable-anchor": ["top", "left", "right"],
          "text-offset": [1.5, 1.5],
          "text-optional": true,
          "text-allow-overlap": false,
          "text-ignore-placement": false
        },
        paint: {
          "text-color": SYMBOL_TEXT_COLOR,
          "text-halo-color": "rgba(255,255,255,1)",
          "text-halo-width": 1
        }
      });
      map.fire("displayHoverPopup", e);
    });
    // Change it back to a pointer when it leaves.
    map.on("mouseleave", "highlight-desktopDestinations", () => {
      const layer = map.getLayer("highlight-desktopDestinations");
      if (typeof layer !== "undefined") {
        // Remove map layer & source.
        map
          .removeLayer("highlight-desktopDestinations")
          .removeSource("highlight-desktopDestinations");
      }
      // Remove HoverPopUp
      map.fire("removeHoverPopup");
    });
    map.on("mouseleave", "desktopDestinations", () => {
      map.getCanvas().style.cursor = "";
      // Remove HoverPopUp
      map.fire("removeHoverPopup");
    });
  },
  initMobileDestinationsLayer(map, destinations) {
    const locationsOfDestinations = destinations.map(destination => {
      let location = destination.location;
      location.properties.mainPicture = destination.mainPicture;
      location.properties.destinationId = destination.id;
      location.properties.category = destination.category.nameEn.replace(
        /\s/g,
        ""
      );
      return location;
    });
    // RESET Layer before new destinations display
    const layer = map.getLayer("MobileDestinations");
    if (typeof layer !== "undefined") {
      // Remove map layer & source.
      map.removeLayer("MobileDestinations").removeSource("MobileDestinations");
    }
    map.addLayer({
      id: "MobileDestinations",
      type: "symbol",
      source: {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: locationsOfDestinations
        }
      },
      layout: {
        "icon-image": ["get", "category"],
        "icon-size": 1,
        "icon-anchor": "center",
        "icon-allow-overlap": true,
        "icon-ignore-placement": false,
        "symbol-sort-key": 1000,
        "text-field": ["get", "shortName"],
        "text-size": SYMBOL_TEXT_FONTSIZE,
        "text-font": SYMBOL_TEXT_FONTS,
        "text-variable-anchor": ["top", "left", "right"],
        "text-offset": [1.5, 1.5],
        "text-optional": true,
        "text-allow-overlap": false,
        "text-ignore-placement": false
      },
      paint: {
        "text-color": SYMBOL_TEXT_COLOR,
        "text-halo-color": "rgba(255,255,255,1)",
        "text-halo-width": 1
      }
    });
  },
  addHoverActiveDestinationLayer(map, destination) {
    map.addLayer({
      id: "hoverActiveDestination",
      type: "symbol",
      source: {
        type: "geojson",
        data: destination.location
      },
      layout: {
        "icon-image": [
          "concat",
          ["get", "category"],
          "-hoverActiveDestination"
        ],
        "icon-size": 1,
        "icon-anchor": "center",
        "icon-allow-overlap": true,
        "icon-ignore-placement": false,
        "symbol-sort-key": 1000,
        "text-field": ["get", "shortName"],
        "text-size": SYMBOL_TEXT_FONTSIZE,
        "text-font": HOVER_ACTIVE_SYMBOL_TEXT_FONTS,
        "text-variable-anchor": ["top", "left", "right"],
        "text-offset": [1.5, 1.5],
        "text-optional": true,
        "text-allow-overlap": false,
        "text-ignore-placement": false
      },
      paint: {
        "text-color": SYMBOL_TEXT_COLOR,
        "text-halo-color": "rgba(255,255,255,1)",
        "text-halo-width": 1
      }
    });
  },
  removeHoverActiveDestinationLayer(map) {
    map.removeLayer("hoverActiveDestination");
    map.removeSource("hoverActiveDestination");
  },
  addActiveDestinationLayer(map, destination) {
    map.addLayer({
      id: "activeDestination",
      type: "symbol",
      source: {
        type: "geojson",
        data: destination.location
      },
      layout: {
        "icon-image": [
          "concat",
          ["get", "category"],
          "-hoverActiveDestination"
        ],
        "icon-size": 1,
        "icon-anchor": "center",
        "icon-allow-overlap": true,
        "icon-ignore-placement": false,
        "symbol-sort-key": 1000,
        "text-field": ["get", "shortName"],
        "text-size": SYMBOL_TEXT_FONTSIZE,
        "text-font": ACTIVE_SYMBOL_TEXT_FONTS,
        "text-anchor": "top",
        "text-offset": [0, 1.5],
        "text-optional": true,
        "text-allow-overlap": false,
        "text-ignore-placement": false
      },
      paint: {
        "text-color": SYMBOL_TEXT_COLOR,
        "text-halo-color": "rgba(255,255,255,1)",
        "text-halo-width": 1
      }
    });
  },
  removeActiveDestinationLayer(map) {
    map.removeLayer("activeDestination");
    map.removeSource("activeDestination");
  },
  initBounds(longitude, latitude, placeType) {
    return new Promise((resolve, reject) => {
      if (placeType == "country") {
        let bounds = this.bboxToBounds(this.getFranceBbox());
        resolve(bounds);
      } else if (placeType == "region") {
        let bbox = null;
        GeoappAPI.retrieveRegionAPI(longitude, latitude)
          .then(response => {
            bbox = response.data.bbox;
            let bounds = this.bboxToBounds(bbox);
            resolve(bounds);
          })
          .catch(error => {
            reject(error);
          });
      } else {
        let bbox = null;
        GeoappAPI.retrieveCityAPI(longitude, latitude)
          .then(response => {
            bbox = response.data.bbox;
            let bounds = this.bboxToBounds(bbox);
            resolve(bounds);
          })
          .catch(error => {
            reject(error);
          });
      }
    });
  },
  getBboxFromMap(map) {
    let boundsArray = map.getBounds().toArray();
    let bbox = {};
    bbox["xMin"] = boundsArray[0][0];
    bbox["yMin"] = boundsArray[0][1];
    bbox["xMax"] = boundsArray[1][0];
    bbox["yMax"] = boundsArray[1][1];
    return bbox;
  },
  bboxToBounds(bbox) {
    let corner1 = new mapboxgl.LngLat(bbox.x_min, bbox.y_min);
    let corner2 = new mapboxgl.LngLat(bbox.x_max, bbox.y_max);
    let bounds = new mapboxgl.LngLatBounds(corner1, corner2);
    return bounds;
  },
  getFranceBbox() {
    let bbox = {};
    bbox["x_min"] = -5.4534286;
    bbox["y_min"] = 41.2632185;
    bbox["x_max"] = 9.8678344;
    bbox["y_max"] = 51.268318;
    return bbox;
  },
  getMaxBbox() {
    let bbox = {};
    bbox["x_min"] = -10.0;
    bbox["y_min"] = 36.0;
    bbox["x_max"] = 15.0;
    bbox["y_max"] = 54.0;
    return bbox;
  }
};
